import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import Modal from 'react-modal'
import moment from 'moment'

import {
  getNotesSent,
  closeCollabNote,
  updateCollabNote,
  archiveCollabNote,
  createCollabNote,
  deleteCollabNote,
} from '_modules/collaboration/actions'

import ListCard from './list-card'
import NoteForm from './note-form'
import NoteDetails from './note-details'
import styles from './styles.css'

Modal.setAppElement('body')

const mapStateToProps = ({ settings, user, collab }) => ({
  settings,
  user,
  collab,
})

const mapDispatchToProps = {
  getNotesSent,
  closeCollabNote,
  updateCollabNote,
  archiveCollabNote,
  createCollabNote,
  deleteCollabNote,
}

class SentMessagePanel extends Component {
  static propTypes = {
    user: ImmutableProptypes.map,
    collab: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    getNotesSent: PropTypes.func.isRequired,
    closeCollabNote: PropTypes.func.isRequired,
    updateCollabNote: PropTypes.func.isRequired,
    archiveCollabNote: PropTypes.func.isRequired,
    createCollabNote: PropTypes.func.isRequired,
    deleteCollabNote: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
    settings: new Map(),
    collab: new Map(),
  }

  state = {
    modalIsOpen: false,
    showArchived: false,
    sentNotes: [],
    selectedNoteId: '',
  }

  componentWillMount() {
    this.callApis()
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
  }

  getState = props => {
    const sentNotes = props.collab
      .get('notesSent')
      .toArray()
      .sort((a, b) => {
        if (moment(a.createdAt).isBefore(moment(b.createdAt))) return 1
        return -1
      })

    this.setState({ sentNotes })
  }

  callApis = () => {
    this.props.getNotesSent()
  }

  toggleShowArchived = () => {
    this.setState({
      showArchived: !this.state.showArchived,
    })
  }

  onExpandCard = id => {
    this.setState({
      modalIsOpen: true,
      selectedNoteId: id,
    })
  }

  onOpenedNote = payload => {
    this.props.updateCollabNote(payload)
  }

  onResolveNote = () => {
    const { selectedNoteId: noteId } = this.state
    this.props.closeCollabNote({ noteId })
  }

  onReopenNote = payload => {
    this.props.updateCollabNote(payload)
  }

  onSendNote = payload => {
    this.props.createCollabNote(payload)
  }

  onUpdateNote = payload => {
    this.props.updateCollabNote(payload)
  }

  onDeleteNote = noteId => {
    this.props.deleteCollabNote({ noteId })
  }

  onArchiveNote = noteId => {
    this.props.archiveCollabNote({ noteId })
  }

  afterOpenModal = () => {
    // focus form input
  }

  closeModal = () =>
    this.setState({
      modalIsOpen: false,
      showNoteForm: false,
      selectedNoteId: '',
    })

  renderCard = card => {
    if (card.toUser) {
      return (
        <ListCard
          key={card._id}
          id={card._id}
          name={`${card.toUser.name.first} ${card.toUser.name.last}`}
          email={card.toUser.email}
          status={card.toUser.status}
          sentDate={card.createdAt}
          subject={card.subject}
          noteStatus={card.noteStatus}
          onExpandCard={this.onExpandCard}
          onDeleteCard={this.onDeleteNote}
        />
      )
    }
  }

  render() {
    const { user } = this.props
    const { sentNotes, selectedNoteId, showArchived } = this.state
    const noteData = sentNotes.find(n => n._id === selectedNoteId)
    const openNotes = sentNotes.filter(x => x.noteStatus <= 3 && x.toUser)
    const archivedNotes = sentNotes.filter(x => x.noteStatus === 4)

    const noOpenNotes = openNotes.length === 0

    return (
      <div className={styles.container}>
        <div style={{ flex: 0.9, overflowY: 'scroll' }}>
          {noOpenNotes ? (
            <div style={{ color: 'rgba(255,255,255,0.5)', padding: 30, fontSize: 15 }}>
              No unresolved sent messages.
            </div>
          ) : (
            openNotes.map(this.renderCard)
          )}
          {showArchived && (
            <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 10 }}>
              <div style={{ color: 'white', fontSize: 16, alignSelf: 'center' }}>Archived</div>
              {archivedNotes.map(this.renderCard)}
            </div>
          )}
        </div>
        <div style={{ flex: 0.1 }}>
          <button className={styles.button} onClick={this.callApis}>
            Refresh
          </button>
          <button className={styles.button} onClick={this.toggleShowArchived}>
            {showArchived ? 'Show Open' : 'Show Archived'}
          </button>
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className={styles.modal}
          overlayClassName={styles.overlay}
          shouldCloseOnOverlayClick
        >
          {noteData && noteData.noteStatus <= 3 && (
            <NoteForm
              noteData={noteData}
              toUser={noteData.toUser._id}
              onUpdate={this.onUpdateNote}
              onSend={this.onSendNote}
              onCancel={this.closeModal}
              onDelete={this.onDeleteNote}
              onArchive={this.onArchiveNote}
            />
          )}
          {noteData && noteData.noteStatus === 4 && (
            <NoteDetails
              noteId={noteData._id}
              subject={noteData.subject}
              urgencyType={noteData.urgencyType}
              preferredResponse={noteData.preferredResponse}
              status={noteData.noteStatus}
              message={noteData.message}
              sentDate={noteData.createdAt}
              toUser={`${noteData.toUser.name.first} ${noteData.toUser.name.last} <${
                noteData.toUser.email
              }>`}
              onOpened={this.onOpenedNote}
              onResolve={this.onResolveNote}
              onReopen={this.onReopenNote}
              onCancel={this.closeModal}
            />
          )}
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SentMessagePanel)



// WEBPACK FOOTER //
// ./src/views/collaborate/sent-message-panel/index.js